import React from "react"
import {Alert} from "@mui/material"

// Shown in place of projection results when a projection can't be calculated (FutureCalc.calcError). The views that
// produce projections show this and clear their results, so no chart, table, report or score uses a failed projection.
const ProjectionErrorAlert = ({message}: {message?: string}) => {
  if (!message) {
    return null
  }
  return (
    <Alert severity="error" sx={{my: 1}} data-testid="projection-error">
      This projection can't be calculated. {message}
    </Alert>
  )
}

export default ProjectionErrorAlert
